import {isCartStep} from "../functions";
import {Layout} from "./layout";
import {isLogged} from "../customer";

var render = function () {

	var table = '';

	if (isLogged()) {
		var query = new URLSearchParams(location.search)
		var link = query.get('link');

		setTimeout(function() {
			window.location.href = link;
		}, 5000);

		return Layout(`<article>
   <div>
      <div id="order-step-3" class="delivery order-page">
         <div class="tac">
            <h2>Vaše předplatné čeká na autorizaci platební karty</h2>
            <div class="online-payment-action">
               <p>
                  Pro dokončení přeplatného pokračujte kliknutím na tlačítko níže. Tím autorizujete platební kartu uhrazením částky 1 Kč.
               </p>
               <div class="suspend-redirect">
                  <div class="&quot;tac" top-2rem&quot;="">
                  <a href="${link}" id="onlinePaymentButton" class="button big-button success" title="Kliknutím zaplatíte online">
                  Kliknutím přejdete k autorizaci karty online
                  </a>
               </div>
            </div>
            <p class="top-2rem">
               anebo budete do 5 sekund automaticky přesměrováni
            </p>
         </div>
      </div>
     
   </div>
   </div>
</article>`, 1);
	} else {
		return Layout('<p>Musíte být přihlášen</p>', 1)
	}
}

if ($('body').hasClass('in-predplatne') && isCartStep(4)) {
	$('#main-in').html(render())
}